// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"23a412f5fd4cc792","9199":"7b45dbc6ba7a43f0","9603":"7b45dbc6ba7a43f0"}[chunkId] + ".css";
};